const React = require('react');
const T = require('prop-types');
const { useTheme } = require('@material-ui/core/styles');

const IndicatorLabel = ({ values, description, ...props }) => {

    const theme = useTheme();

    return (
        <div
            style={{
                background: 'white',
                boxShadow: theme.boxShadow.light,
                borderRadius: '7px',
                padding: theme.spacing(1.5, 4, 1),
                width: 'fit-content'
            }}
        >
            <svg
                width='292px'
                height='62px'
                viewBox='0 0 292 62'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
                {...props}
            >
                <title>Indicator Label</title>
                <g id='V0.2' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                    <g id='Desktop_V0.2' transform='translate(-342.000000, -1681.000000)'>
                        <g id='Group-4' transform='translate(342.000000, 1681.000000)'>
                            <text id='150,000-to-300,000' fontFamily='SourceSansPro-Black, Source Sans Pro' fontSize='27' fontWeight='700' line-spacing='50' letterSpacing='-0.771428571' fill='#292929'>
                                <tspan x='66' y='27'>{values}</tspan>
                            </text>
                            <text id='TOTAL-PRODUCTION-WAT' fontFamily='SourceSansPro-Regular, Source Sans Pro' fontSize='13' fontWeight='normal' line-spacing='26' letterSpacing='1' fill='#C5C5C5'>
                                <tspan x='66' y='49'>{description}</tspan>
                            </text>
                            <circle id='Oval' fillOpacity='0.0693564248' fill='#0060BF' cx='23' cy='35' r='23' />
                            <path d='M23.0182247,45.4 C26.3127909,45.3903578 29.0248543,42.6728547 28.9998282,39.4206884 C28.9649127,34.8788994 24.7296069,30.0598378 23.2956108,25.2194996 C23.2521784,25.0728746 23.1260791,25 23.0000202,25 C22.8739209,25 22.7478216,25.0728746 22.7043892,25.2194996 C21.2704334,30.0598378 17.0350873,34.8788994 17.0001718,39.4206884 C16.9751457,42.6728547 19.6872091,45.3903578 22.9817753,45.4' id='Path-Copy' fill='#0060BF' fillRule='nonzero' />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

IndicatorLabel.propTypes = {
    height: T.number,
    width: T.number,
    values: T.string,
    description: T.string
};

const StepOne = (props) => (

    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='297'
        height='256'
        viewBox='0 0 297 256'
        {...props}
    >
        <defs>
            <path id='path-1' d='M0 0L5 5 10 0z' />
        </defs>
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g transform='translate(-156 -1088)'>
                <g transform='translate(157 1089)'>
                    <path
                        stroke='#8F96A0'
                        d='M0 4a4 4 0 014-4h133a4 4 0 014 4v38h150a4 4 0 014 4v204a4 4 0 01-4 4H4a4 4 0 01-4-4V4z'
                        opacity='0.3'
                    />
                    <text
                        fill='#0060BF'
                        fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                        fontSize='15'
                        fontWeight='500'
                    >
                        <tspan x='27' y='29'>
                            Single utility
                        </tspan>
                    </text>
                    <text
                        fill='#283643'
                        fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                        fontSize='15'
                        fontWeight='500'
                    >
                        <tspan x='166.925' y='29'>
                            Multiple utilities
                        </tspan>
                    </text>
                    <g transform='translate(26 58)'>
                        <text
                            fill='#283643'
                            fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                            fontSize='16'
                            fontWeight='500'
                            letterSpacing='0.6'
                        >
                            <tspan x='0.453' y='16.487'>
                                UTILITY
                            </tspan>
                        </text>
                        <rect
                            width='242'
                            height='56'
                            x='0'
                            y='50'
                            fill='#FFF'
                            stroke='#D4D7D9'
                            rx='4'
                        />
                        <path d='M9.819 69.926H10.819V86.767H9.819z' />
                        <text
                            fill='#283643'
                            fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                            fontSize='18'
                            fontWeight='500'
                            letterSpacing='0.1'
                        >
                            <tspan x='13' y='84.586'>
                                Bath
                            </tspan>
                        </text>
                        <g transform='translate(8 40.586)'>
                            <path fill='#FFF' d='M0 0H80V20H0z' />
                            <text
                                fill='#283643'
                                fontFamily='SourceSansPro-Regular, Source Sans Pro'
                                fontSize='12'
                                fontWeight='normal'
                                letterSpacing='0.4'
                            >
                                <tspan x='4' y='16'>
                                    Select Utility
                                </tspan>
                            </text>
                        </g>
                        <g transform='translate(215 77.586)'>
                            <mask fill='#fff'>
                                <use xlinkHref='#path-1' />
                            </mask>
                            <use fill='#283643' xlinkHref='#path-1' />
                        </g>
                    </g>
                    <text
                        fill='#9AA0AA'
                        fontFamily='SourceSansPro-Regular, Source Sans Pro'
                        fontSize='14'
                        fontWeight='normal'
                    >
                        <tspan x='25' y='198'>
                            Select a single utility, multiple utilities{' '}
                        </tspan>
                        <tspan x='25' y='220'>
                            or filter parameters.
                        </tspan>
                    </text>
                </g>
            </g>
        </g>
    </svg>
);

const StepTwo = (props) => (

    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='297'
        height='254'
        viewBox='0 0 297 254'
        {...props}
    >
        <defs>
            <path id='path-1' d='M0 0L5 5 10 0z' />
        </defs>
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g transform='translate(-571 -1090)'>
                <g transform='translate(572 1091)'>
                    <rect
                        width='295'
                        height='252'
                        x='0'
                        y='0'
                        stroke='#8F96A0'
                        opacity='0.3'
                        rx='4'
                    />
                    <g transform='translate(26 25)'>
                        <text
                            fill='#2D3D4C'
                            fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                            fontSize='16'
                            fontWeight='500'
                            letterSpacing='0.6'
                        >
                            <tspan x='0.453' y='16.487'>
                                YEAR
                            </tspan>
                        </text>
                        <rect
                            width='242'
                            height='56'
                            x='0'
                            y='50'
                            fill='#FFF'
                            stroke='#D4D7D9'
                            rx='4'
                        />
                        <path d='M9.819 69.926H10.819V86.767H9.819z' />
                        <text
                            fill='#2D3E4C'
                            fontFamily='SourceSansPro-SemiBold, Source Sans Pro'
                            fontSize='18'
                            fontWeight='500'
                            letterSpacing='0.1'
                        >
                            <tspan x='13' y='84.586'>
                                2017
                            </tspan>
                        </text>
                        <g transform='translate(8 40.586)'>
                            <path fill='#FFF' d='M0 0H70V20H0z' />
                            <text
                                fill='#2D3E4C'
                                fontFamily='SourceSansPro-Regular, Source Sans Pro'
                                fontSize='12'
                                fontWeight='normal'
                                letterSpacing='0.4'
                            >
                                <tspan x='4' y='16'>
                                    Select Year
                                </tspan>
                            </text>
                        </g>
                        <g transform='translate(215 77.586)'>
                            <mask fill='#fff'>
                                <use xlinkHref='#path-1' />
                            </mask>
                            <use fill='#283643' xlinkHref='#path-1' />
                        </g>
                    </g>
                    <text
                        fill='#9AA0AA'
                        fontFamily='SourceSansPro-Regular, Source Sans Pro'
                        fontSize='14'
                        fontWeight='normal'
                    >
                        <tspan x='25' y='165'>
                            Select a single year, or select{' '}
                        </tspan>
                        <tspan x='25' y='187'>
                            a range of years.
                        </tspan>
                    </text>
                </g>
            </g>
        </g>
    </svg>
);

const StepThree = (props) => (

    <svg
        width='297px'
        height='254px'
        viewBox='0 0 297 254'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <title>Step 3</title>
        <defs>
            <rect id='path-1' x='966' y='1067' width='339' height='298' rx='7' />
            <filter x='-6.6%' y='-7.6%' width='113.3%' height='115.1%' filterUnits='objectBoundingBox' id='filter-2'>
                <feOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter1' />
                <feGaussianBlur stdDeviation='7.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' />
                <feColorMatrix values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0886418269 0' type='matrix' in='shadowBlurOuter1' />
            </filter>
            <rect id='path-3' x='1.13686838e-13' y='0' width='295' height='252' rx='4' />
            <linearGradient x1='50%' y1='3.49675925%' x2='50%' y2='58.6237814%' id='linearGradient-5'>
                <stop stopColor='#32CB6D' offset='0.0846809441%' />
                <stop stopColor='#C8FFDD' offset='49.9762458%' />
                <stop stopColor='#FCF4F3' stopOpacity='0' offset='82.9576647%' />
                <stop stopColor='#FFFFFF' stopOpacity='0.0192307692' offset='100%' />
            </linearGradient>
        </defs>
        <g id='V0.2' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Desktop_V0.2' transform='translate(-987.000000, -1090.000000)'>
                <g id='Rectangle-Copy-7'>
                    <use fill='black' fillOpacity='1' filter='url(#filter-2)' xlinkHref='#path-1' />
                    <use fill='#FFFFFF' fillRule='evenodd' xlinkHref='#path-1' />
                </g>
                <g id='Group-6' transform='translate(988.000000, 1091.000000)'>
                    <g id='Path-4-+-Oval-Mask' transform='translate(-0.000000, 0.000000)'>
                        <mask id='mask-4' fill='white'>
                            <use xlinkHref='#path-3' />
                        </mask>
                        <use id='Mask' stroke='#8F96A0' opacity='0.300000012' xlinkHref='#path-3' />
                        <path d='M321.503409,83.4308547 C323.755378,81.8884162 325.884506,81.3589327 327.868021,81.697639 C329.830701,82.0327874 331.709173,83.235172 333.436076,85.436159 C336.442892,89.2684314 339.065891,96.3219118 341.203447,106.654895 C345.36846,126.788646 347.841064,159.588108 348.60272,205.056003 L348.60272,205.056003 L317.929778,466.591625 L-260.4,466.591625 L-260.4,231.452944 C-253.488798,236.609206 -240.445874,237.96559 -221.358194,235.794864 C-211.556793,234.68021 -207.042785,227.130182 -202.704655,220.171141 C-198.256714,213.035949 -193.949544,206.539079 -185.899654,205.878293 C-180.024385,205.396014 -172.002045,208.061272 -160.189754,216.444188 C-155.487352,219.781376 -151.417525,221.65494 -147.831264,222.308516 C-144.129214,222.983194 -140.980167,222.323571 -138.228937,220.667831 C-130.924722,216.272023 -126.331551,205.332067 -121.660193,193.896983 L-121.192693,192.752048 L-121.192693,192.752048 L-120.958554,192.178763 L-120.958554,192.178763 L-120.340155,190.666743 L-120.340155,190.666743 L-119.718832,189.154334 C-115.979791,180.084115 -112.019776,171.138781 -106.702597,164.944934 C-102.187962,159.68595 -96.712551,156.371986 -89.6710938,156.371986 C-73.3736747,156.371986 -64.3457967,163.507494 -56.1712411,170.895201 L-55.5596492,171.449644 C-55.4579504,171.542094 -55.3563599,171.634557 -55.2548652,171.727018 L-54.6469454,172.28167 L-54.6469454,172.28167 L-54.3436591,172.558786 C-53.6948785,173.151714 -53.0486392,173.742977 -52.4011269,174.328407 L-51.8457157,174.828677 C-43.877802,181.975949 -35.5532485,188.062708 -19.7988813,185.354751 C-14.0508756,184.366749 -10.137159,179.605326 -5.5717264,174.289807 L-5.26767856,173.935925 C0.52584603,167.196104 7.28953221,159.568929 18.968366,156.000326 C27.2684828,153.464129 38.0770247,152.969368 52.8502332,156.408445 C84.7143794,163.826145 106.288019,143.938194 126.88514,125.202598 C140.093136,113.188313 152.925293,101.592317 167.602276,97.2435807 C189.369851,90.7939288 205.370566,94.573303 220.895348,99.2525312 L221.965332,99.5765499 C222.321785,99.6849562 222.678051,99.7937246 223.034193,99.9027419 L225.170088,100.558925 C249.783759,108.135774 274.415377,115.682805 321.503409,83.4308547 Z' id='Path-4' stroke='#32CB6D' strokeWidth='2.8' fillOpacity='0.300000012' fill='url(#linearGradient-5)' strokeLinecap='round' strokeLinejoin='round' mask='url(#mask-4)' />
                        <circle id='Oval' stroke='#32CB6D' strokeWidth='3' fill='#FFFFFF' mask='url(#mask-4)' cx='192.9' cy='94.085898' r='8' />
                    </g>
                    <text id='value' fontFamily='SourceSansPro-SemiBold, Source Sans Pro' fontSize='16' fontWeight='500' line-spacing='16' fill='#2D3E4C'>
                        <tspan x='25' y='41'>Utility</tspan>
                    </text>
                    <text id='value-copy' fontFamily='SourceSansPro-SemiBold, Source Sans Pro' fontSize='16' fontWeight='500' line-spacing='16' fill='#283643'>
                        <tspan x='94' y='41'>Year</tspan>
                    </text>
                    <text id='value' fontFamily='SourceSansPro-Regular, Source Sans Pro' fontSize='16' fontWeight='normal' line-spacing='30' fill='#A4AAB3'>
                        <tspan x='25' y='58'>Bath</tspan>
                    </text>
                    <text id='value-copy-2' fontFamily='SourceSansPro-Regular, Source Sans Pro' fontSize='16' fontWeight='normal' line-spacing='30' fill='#8F96A0'>
                        <tspan x='94' y='58'>2017</tspan>
                    </text>
                </g>
            </g>
        </g>
    </svg>
);

module.exports = {
    IndicatorLabel,
    StepOne,
    StepTwo,
    StepThree
};

